<script lang="ts">
  import type { Locale } from "$lib/paraglide/runtime";
  import Dropdown from "@brave/leo/src/components/dropdown/dropdown.svelte";
  import Icon from "@brave/leo/src/components/icon/icon.svelte";

  export let currentLocale: string = "en";
  export let locales: Readonly<string[]> = [];
  export let handleChange: (detail: { value: Locale }) => void = undefined;

  type LocaleDisplay = {
    name: string;
  };
  const localeDisplayMap: Record<string, LocaleDisplay> = {
    en: {
      name: "English",
    },
    id: {
      name: "Bahasa Indonesia",
    },
    ms: {
      name: "Bahasa Melayu",
    },
    ca: {
      name: "Català",
    },
    cs: {
      name: "Čeština",
    },
    da: {
      name: "Dansk",
    },
    de: {
      name: "Deutsch",
    },
    et: {
      name: "Eesti",
    },
    es: {
      name: "Español",
    },
    fr: {
      name: "Français",
    },
    hr: {
      name: "Hrvatski",
    },
    it: {
      name: "Italiano",
    },
    lv: {
      name: "Latviešu",
    },
    lt: {
      name: "Lietuvių",
    },
    hu: {
      name: "Magyar",
    },
    nl: {
      name: "Nederlands",
    },
    nb: {
      name: "Norsk",
    },
    pl: {
      name: "Polski",
    },
    pt: {
      name: "Português",
    },
    ro: {
      name: "Română",
    },
    sk: {
      name: "Slovenčina",
    },
    sl: {
      name: "Slovenščina",
    },
    fi: {
      name: "Suomi",
    },
    sv: {
      name: "Svenska",
    },
    vi: {
      name: "Tiếng Việt",
    },
    tr: {
      name: "Türkçe",
    },
    el: {
      name: "Ελληνικά",
    },
    bg: {
      name: "Български",
    },
    ru: {
      name: "Русский",
    },
    sr: {
      name: "Српски",
    },
    uk: {
      name: "Українська",
    },
    ka: {
      name: "ქართული",
    },
    hi: {
      name: "हिन्दी",
    },
    th: {
      name: "ไทย",
    },
    ko: {
      name: "한국어",
    },
    "zh-tw": {
      name: "中文 (繁體)",
    },
    zh: {
      name: "中文（简体）",
    },
    ja: {
      name: "日本語",
    },
  };
</script>

<Dropdown mode="plain" bind:value={currentLocale} onChange={handleChange}>
  <svelte:fragment slot="value">{localeDisplayMap[currentLocale]?.name}</svelte:fragment>
  <Icon slot="left-icon" name="product-translate" />
  {#each locales as locale}
    {@const { name } = localeDisplayMap[locale] || {}}
    <leo-option value={locale}>
      {name}
    </leo-option>
  {/each}
</Dropdown>
